var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 82,
    viewBox: "0 0 111 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.00195,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6.00195,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 6.00195,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 6.00195,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 6.00195,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 6.00195,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 6.00195,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 6.00195,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 6.00195,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 6.00195,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 16.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 16.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16.002,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 16.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 16.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 16.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 16.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 26.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 26.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 26.002,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 26.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 26.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 26.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 26.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 36.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 36.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 36.002,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 36.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 36.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 36.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 36.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 46.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 46.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 46.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 46.002,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 46.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 46.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 46.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 46.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 56.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 56.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 56.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 56.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56.002,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 56.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 56.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 56.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 56.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 66.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 66.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 66.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 66.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 66.002,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 66.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 66.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 66.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 66.002,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.2
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4414,
    y: 29.4531,
    width: 23.0986,
    height: 51.9774,
    transform: "rotate(-90 29.4414 29.4531)",
    fill: "#EDE1E4",
    stroke: "#794E57",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4063 75.4531C82.3017 75.4531 81.4062 74.5577 81.4062 73.4531V6.35547H102.506C103.611 6.35547 104.506 7.2509 104.506 8.35547V73.4531C104.506 74.5577 103.611 75.4531 102.506 75.4531H83.4063Z",
    fill: "#EDE1E4",
    stroke: "#794E57",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 75.4531C7.23918 75.4531 6.34375 74.5577 6.34375 73.4531L6.34375 8.35547C6.34375 7.2509 7.23918 6.35547 8.34375 6.35547H29.4438L29.4438 73.4531C29.4438 74.5577 28.5483 75.4531 27.4438 75.4531H8.34375Z",
    fill: "#EDE1E4",
    stroke: "#794E57",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2317 22.3263C55.619 22.3263 55.9527 22.282 56.2327 22.1933C56.5127 22.1046 56.7414 21.981 56.9187 21.8223C57.1007 21.659 57.2337 21.4676 57.3177 21.2483C57.4017 21.0243 57.4437 20.7793 57.4437 20.5133C57.4437 19.9953 57.2594 19.587 56.8907 19.2883C56.522 18.985 55.969 18.8333 55.2317 18.8333H53.0617V22.3263H55.2317ZM53.0617 14.4443V17.8673H54.8537C55.2364 17.8673 55.5677 17.8253 55.8477 17.7413C56.1324 17.6573 56.3657 17.5406 56.5477 17.3913C56.7344 17.242 56.872 17.0623 56.9607 16.8523C57.0494 16.6376 57.0937 16.4043 57.0937 16.1523C57.0937 15.5596 56.9164 15.128 56.5617 14.8573C56.207 14.582 55.6564 14.4443 54.9097 14.4443H53.0617ZM54.9097 13.3733C55.5257 13.3733 56.0554 13.434 56.4987 13.5553C56.9467 13.6766 57.313 13.8493 57.5977 14.0733C57.887 14.2973 58.0994 14.5726 58.2347 14.8993C58.37 15.2213 58.4377 15.5853 58.4377 15.9913C58.4377 16.2386 58.398 16.4766 58.3187 16.7053C58.244 16.9293 58.1297 17.1393 57.9757 17.3353C57.8217 17.5313 57.6257 17.7086 57.3877 17.8673C57.1544 18.0213 56.879 18.1473 56.5617 18.2453C57.299 18.3853 57.852 18.649 58.2207 19.0363C58.594 19.419 58.7807 19.923 58.7807 20.5483C58.7807 20.973 58.7014 21.3603 58.5427 21.7103C58.3887 22.0603 58.16 22.3613 57.8567 22.6133C57.558 22.8653 57.1894 23.0613 56.7507 23.2013C56.312 23.3366 55.8127 23.4043 55.2527 23.4043H51.7107V13.3733H54.9097Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.28 44.3323C96.3547 44.3323 96.42 44.3626 96.476 44.4233L97.015 45.0043C96.6044 45.4803 96.105 45.8513 95.517 46.1173C94.9337 46.3833 94.2267 46.5163 93.396 46.5163C92.6774 46.5163 92.024 46.3926 91.436 46.1453C90.848 45.8933 90.3464 45.5433 89.931 45.0953C89.5157 44.6426 89.1937 44.1013 88.965 43.4713C88.7364 42.8413 88.622 42.1483 88.622 41.3923C88.622 40.6363 88.741 39.9433 88.979 39.3133C89.217 38.6833 89.5507 38.142 89.98 37.6893C90.414 37.2366 90.932 36.8866 91.534 36.6393C92.136 36.3873 92.801 36.2613 93.529 36.2613C94.243 36.2613 94.873 36.3756 95.419 36.6043C95.965 36.833 96.4457 37.1433 96.861 37.5353L96.413 38.1583C96.385 38.205 96.3477 38.2446 96.301 38.2773C96.259 38.3053 96.2007 38.3193 96.126 38.3193C96.042 38.3193 95.9394 38.275 95.818 38.1863C95.6967 38.093 95.538 37.9903 95.342 37.8783C95.146 37.7663 94.901 37.666 94.607 37.5773C94.313 37.484 93.9514 37.4373 93.522 37.4373C93.004 37.4373 92.5304 37.5283 92.101 37.7103C91.6717 37.8876 91.3007 38.1466 90.988 38.4873C90.68 38.828 90.4397 39.2433 90.267 39.7333C90.0944 40.2233 90.008 40.7763 90.008 41.3923C90.008 42.0176 90.0967 42.5753 90.274 43.0653C90.456 43.5553 90.701 43.9706 91.009 44.3113C91.3217 44.6473 91.688 44.904 92.108 45.0813C92.5327 45.2586 92.99 45.3473 93.48 45.3473C93.7787 45.3473 94.047 45.331 94.285 45.2983C94.5277 45.261 94.7494 45.205 94.95 45.1303C95.1554 45.0556 95.3444 44.9623 95.517 44.8503C95.6944 44.7336 95.8694 44.596 96.042 44.4373C96.1214 44.3673 96.2007 44.3323 96.28 44.3323Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5025 42.6803L17.9275 38.5993C17.8809 38.478 17.8319 38.338 17.7805 38.1793C17.7292 38.016 17.6802 37.8433 17.6335 37.6613C17.5355 38.0393 17.4352 38.3543 17.3325 38.6063L15.7575 42.6803H19.5025ZM22.3305 46.4043H21.2805C21.1592 46.4043 21.0612 46.374 20.9865 46.3133C20.9119 46.2526 20.8559 46.1756 20.8185 46.0823L19.8805 43.6603H15.3795L14.4415 46.0823C14.4135 46.1663 14.3599 46.241 14.2805 46.3063C14.2012 46.3716 14.1032 46.4043 13.9865 46.4043H12.9365L16.9475 36.3733H18.3195L22.3305 46.4043Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77465 0.00195312H105H105.099H111V76.002V82.002H105H81V76.002H105V5.7766H5.77465V76.002H56V82.002H5.77465H0V76.002V5.7766V0.00195312H5.77465Z",
    fill: "#DCDCDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUShape);
export default __webpack_public_path__ + "static/media/u-shape.9d4350fdc22b564595c6abbd1fe27c1a.svg";
export { ForwardRef as ReactComponent };